import { UserManager, WebStorageStateStore } from 'oidc-client';
import store from '../../store';

export default (to, from, next) => {
  if (window.sessionStorage.getItem('storeId') || to.name === 'Callback') {
    return next();
  }
  let conf = {
    authority: process.env.VUE_APP_API_ESSILOR_PRO_AUTHORITY,
    client_id: process.env.VUE_APP_API_ESSILOR_PRO_CLIENT_ID,
    redirect_uri: process.env.VUE_APP_API_ESSILOR_PRO_REDIRECT_URI,
    response_type: process.env.VUE_APP_API_ESSILOR_PRO_RESPONSE_TYPE,
    scope: process.env.VUE_APP_API_ESSILOR_PRO_SCOPE,
    post_logout_redirect_uri: process.env.VUE_APP_API_ESSILOR_PRO_LOGOUT_REDIRECT_URI,
  };
  conf.userStore = new WebStorageStateStore({ store: window.sessionStorage });
  let mgr = new UserManager(conf);
  mgr.getUser().then(user => {
    if (user) {
      window.sessionStorage.setItem('storeId', user.profile.ep_store_id);
      window.sessionStorage.setItem('userRole', user.profile.ep_user_type);
      store.commit('setUser');
    } else {
      window.sessionStorage.setItem('oldPath', to.fullPath);
      mgr.signinRedirect();
    }
  });
  return next();
};
